import { ReactiveFormsModule, FormGroup} from '@angular/forms';
import { Component, Input } from '@angular/core';
import { ExportInterfaceConfigurationType } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { FieldAssignmentsFormComponent } from '../../shared/field-assignments-form/field-assignments-form.component';
import { EnumDropDownListComponent } from '../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';
import { FieldAssignmentTemplateFormType } from './field-assignment-template-form-type';

@Component({
    selector: 'app-field-assignment-template-form',
    templateUrl: './field-assignment-template-form.component.html',
    styleUrls: ['./field-assignment-template-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, EnumDropDownListComponent, FieldAssignmentsFormComponent, TranslateModule]
})
export class FieldAssignmentTemplateFormComponent {

  @Input()
  public templateForm: FormGroup<FieldAssignmentTemplateFormType>;

  public Type = ExportInterfaceConfigurationType;

  constructor() { }
}
